// App Info
export const APP_NAME = 'Kahraman Technology';
export const APP_VERSION = '1.01.18';

// Firebase Configuration
// YENİ FİREBASE PROJESİ İÇİN DEĞERLERİ BURAYA GİRİN
// Firebase Console > Project Settings > Your apps > Web app config değerlerini buraya kopyalayın
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBOlj6ZaEvRUKIPyzvI7tObh8l6N0duz00",
  authDomain: "ayhomelotus-b0941.firebaseapp.com",
  projectId: "ayhomelotus-b0941",
  storageBucket: "ayhomelotus-b0941.firebasestorage.app",
  messagingSenderId: "668833803463",
  appId: "1:668833803463:web:b081fbaff45f0f905922e2",
  measurementId: "G-7XWZKQD6BY"
};

// App Colors
export const COLORS = {
  primary: '#1a1a1a',
  primaryHover: '#333333',
  secondary: '#f5f5f5',
  success: '#4caf50',
  error: '#f44336',
  warning: '#ff9800',
  info: '#2196f3',
  text: '#333',
  textLight: '#666',
  border: '#e1e5e9'
};

// Product Types
export const PRODUCT_TYPES = {
  tul: {
    label: 'Tül',
    fields: ['roomName', 'productName', 'width', 'height', 'pileModel', 'pileDensity', 'usedM2', 'unitPrice', 'extraPrice', 'capsuleUnitPrice', 'capsulePrice', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      // Bu fonksiyon daha sonra detaylı hesaplamalar için kullanılacak
      return 0;
    }
  },
  kanat: {
    label: 'Kanat',
    fields: ['roomName', 'productName', 'width', 'height', 'pileModel', 'pileDensity', 'usedM2', 'unitPrice', 'extraPrice', 'capsuleUnitPrice', 'capsulePrice', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  stor: {
    label: 'Stor',
    fields: ['roomName', 'productName', 'direction', 'width', 'height', 'usedM2', 'unitPrice', 'jumboSystem', 'reductor', 'bottomSkirt', 'closedCase', 'laser', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  zebra: {
    label: 'Zebra',
    fields: ['roomName', 'productName', 'direction', 'width', 'height', 'usedM2', 'unitPrice', 'jumboSystem', 'reductor', 'bottomSkirt', 'closedCase', 'laser', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  ahsapJaluzi: {
    label: 'Ahşap Jaluzi',
    fields: ['roomName', 'productName', 'direction', 'motorType', 'motorPrice', 'hasZigil', 'hasReduktor', 'hasKurdela', 'zigilAmount', 'width', 'height', 'usedM2', 'sistemTipi', 'unitPrice', 'mounting', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  metalJaluzi: {
    label: 'Metal Jaluzi',
    fields: ['roomName', 'productName', 'direction', 'motorType', 'motorPrice', 'hasMetalZigil', 'hasMetalReduktor', 'hasIkiCamArasi', 'metalZigilAmount', 'ikiCamArasiAmount', 'width', 'height', 'usedM2', 'unitPrice', 'mounting', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyPerde: {
    label: 'Dikey Perde',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'hasDikeyFon', 'motorType', 'motorPrice', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyPvc: {
    label: 'Dikey PVC',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'motorType', 'motorPrice', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyStor: {
    label: 'Dikey Stor',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'motorType', 'motorPrice', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  plise: {
    label: 'Plise',
    fields: ['roomName', 'pliseProduct1Name', 'pliseProduct1Price', 'pliseProduct1Variation', 'pliseProduct2Name', 'pliseProduct2Price', 'pliseProduct2Variation', 'width', 'height', 'usedM2', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice', 'notes'],
    calculations: (data) => {
      return 0;
    }
  },
  katlamaliPerde: {
    label: 'Katlamalı Perde',
    fields: ['roomName', 'productName', 'width', 'height', 'usedM2', 'fabricPrice', 'mechanismType', 'mechanismPrice', 'accessoryPrice', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  raySistemi: {
    label: 'Ray Sistemleri',
    fields: ['roomName', 'productName', 'width', 'olcuTamamlama', 'usedMeter', 'unitPrice', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice', 'notes'],
    calculations: (data) => {
      return 0;
    }
  },
  rustik: {
    label: 'Rustik',
    fields: ['roomName', 'productName', 'width', 'unitPrice', 'usedCm', 'ayakModel', 'ayakCap', 'ayakUzunluk', 'ayakRenkKodu', 'ayakSayisi', 'ekAyakSayisi', 'ayakUcreti', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice', 'notes', 'rustikAksesuarlar', 'rustikRaySecenekleri'],
    calculations: (data) => {
      return 0;
    }
  },
  aksesuar: {
    label: 'Aksesuar',
    fields: ['roomName', 'productName', 'quantity', 'unitPrice'],
    calculations: (data) => {
      return 0;
    }
  }
};

// Stor / Zebra ek seçenekleri — ayar kartı, sipariş seçimleri ve hesaplamalar buradan üretilir.
// fixed: true → en ile çarpılmaz, adet başına sabit tutar eklenir; aksi halde (50 cm'ye yuvarlanmış en × fiyat).
// variants: siparişte bunlardan biri seçilir; her çeşidin firma bazında kendi fiyatı vardır (fiyat anahtarı = çeşit key'i).
//   İlk çeşit varsayılandır. Eski tekil fiyatlar aynı anahtarla saklandığı için (jumbo, kapaliKasa, altEtekLazer...) aynen taşınır.
// multiple: true → birden fazla çeşit seçilir ({tip}{Key}Variants dizisi), tutar/maliyet seçilenlerin toplamıdır.
// Sipariş alan adları: has{Tip}{Key}, {tip}{Key}Amount, {tip}{Key}CostAmount, {tip}{Key}Variant (örn. hasStorJumbo, storJumboVariant).
const JUMBO_VARIANTS = [
  { key: 'jumbo', label: 'Jumbo Sistem' },
  { key: 'jumbo38', label: "38'lik Redüktörlü" },
  { key: 'jumbo47', label: "47'lik Redüktörlü" },
  { key: 'jumbo65', label: "65'lik Redüktörlü" },
  { key: 'jumboCiftliXl', label: 'Çiftli XL Mekanizma' }
];
const KAPALI_KASA_VARIANTS = [
  { key: 'kapaliKasa', label: 'Kapalı Kasa' },
  { key: 'kapaliKasaKucuk', label: 'Küçük Kapalı Kasa' },
  { key: 'kapaliKasaBuyuk', label: 'Büyük Kapalı Kasa' },
  { key: 'kapaliKasaCiftli', label: 'Çiftli Sistem Kapalı Kasa' },
  { key: 'kapaliKasaKareKucuk', label: 'Kare Küçük Kapalı Kasa' },
  { key: 'kapaliKasaKareBuyuk', label: 'Kare Büyük Kapalı Kasa' }
];

export const STOR_ZEBRA_EXTRAS = {
  stor: [
    { key: 'jumbo', label: 'Jumbo Sistem', fixed: true, variants: JUMBO_VARIANTS },
    { key: 'kapaliKasa', label: 'Kapalı Kasa', variants: KAPALI_KASA_VARIANTS },
    {
      key: 'etekModeli',
      label: 'Etek Modelleri',
      multiple: true, // birden fazla çeşit seçilebilir; tutar seçilenlerin toplamıdır
      variants: [
        { key: 'etekOyma', label: 'Stor Etek Oyma' },
        { key: 'altEtekBeyazIs', label: 'İşleme (Beyaziş)' },
        { key: 'altEtekLazer', label: 'Lazer Kesim' },
        { key: 'etekYuvarlakAluminyum', label: 'Yuvarlak Alüminyum Etek Çıta' },
        { key: 'etekKareAluminyum', label: 'Kare Alüminyum Etek Çıta' }
      ]
    },
    { key: 'dekoratifLama', label: 'Dekoratif Lama' },
    { key: 'dekoratifKasa', label: 'Dekoratif Kasa' },
    { key: 'metalZincir', label: 'Metal Zincir', fixed: true }
  ],
  zebra: [
    { key: 'jumbo', label: 'Jumbo Sistem', fixed: true, variants: JUMBO_VARIANTS },
    { key: 'altEtekDilim', label: 'Alt Etek Dilim' },
    { key: 'kapaliKasa', label: 'Kapalı Kasa', variants: KAPALI_KASA_VARIANTS },
    { key: 'metalZincir', label: 'Metal Zincir', fixed: true }
  ]
};

// Artık seçilemeyen eski seçenekler: eski siparişlerde işaretliyse hesaba dahil kalır ve kaldırılabilir.
export const STOR_ZEBRA_LEGACY_EXTRAS = {
  stor: [
    { key: 'altEtekDilim', label: 'Alt Etek Dilim' },
    { key: 'altEtekLazer', label: 'Alt Etek Lazer' },
    { key: 'altEtekBeyazIs', label: 'Alt Etek Beyaz İş' }
  ],
  zebra: []
};

// Ahşap ve Metal Jaluzi Sistem Tipleri
export const JALUZI_SISTEM_TIPLERI = {
  merdivenIpli: 'Merdiven İpli',
  kurdeleli: 'Kurdeleli',
  merdivenIpliReduktorlu: 'Merdiven İpli Redüktörlü',
  kurdelaliReduktorlu: 'Kurdelalı Redüktörlü'
};

// Yön Tipleri
export const DIRECTION_TYPES = {
  LEFT: 'Sol',
  RIGHT: 'Sağ'
};

// Dikey Ürün Yön Tipleri
export const DIKEY_DIRECTION_TYPES = {
  SAGA: 'Sağa açılım',
  SOLA: 'Sola açılım',
  ORTADAN: 'Ortadan açılım'
};

// Motor Tipleri
export const MOTOR_TYPES = {
  MOTOR_1: 'Motor',
  MOTOR_2_KUMANDA: 'Motor + Kumanda'
};


// Tül ve Kanat Pile Modelleri
export const TUL_PILE_MODELS = {
  standartSeyrek: 'Standart SEYREK',
  standartOrta: 'Standart ORTA',
  standartSik: 'Standart SIK',
  sPile: 'S Pile',
  amerikanPile2li: 'Amerikan Pile 2\'li',
  amerikanPile3lu: 'Amerikan Pile 3\'lü',
  kapsulPile: 'Kapsül Pile',
  cimaDikis: 'Çima Dikiş',
  duzDikis: 'Düz Dikiş',
  kumasGuneslik: 'Kumaş Güneşlik'
};

// Kanat Pile Modelleri (Tül ile aynı)
export const KANAT_PILE_MODELS = {
  standartSeyrek: 'Standart SEYREK',
  standartOrta: 'Standart ORTA',
  standartSik: 'Standart SIK',
  sPile: 'S Pile',
  amerikanPile2li: 'Amerikan Pile 2\'li',
  amerikanPile3lu: 'Amerikan Pile 3\'lü',
  kapsulPile: 'Kapsül Pile',
  cimaDikis: 'Çima Dikiş',
  duzDikis: 'Düz Dikiş',
  kumasGuneslik: 'Kumaş Güneşlik'
};

// Pile Sıklığı Değerleri
export const PILE_DENSITY_VALUES = {
  standartSeyrek: 2,
  standartOrta: 2.5,
  standartSik: 3,
  sPile: 3,
  amerikanPile2li: 3,
  amerikanPile3lu: 4,
  kapsulPile: 3
};

// Routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/'
};

// Notification Types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_SESSION: 'user_session',
  THEME: 'theme'
};

// Bu tarihten önceki keşif tarihleri hatırlatıcılara girmez (özellik öncesi eski kayıtlar "geciken" görünmesin)
export const KESIF_REMINDER_START_DATE = '2026-10-01';

// Order Status Types
export const ORDER_STATUS = {
  NEW_ORDER: 'new_order',
  FIRMA: 'firma',
  ATOLYE: 'atolye',
  MONTAJ: 'montaj',
  DELIVERED: 'delivered'
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.NEW_ORDER]: 'Yeni Sipariş',
  [ORDER_STATUS.FIRMA]: 'Firma',
  [ORDER_STATUS.ATOLYE]: 'Atölye',
  [ORDER_STATUS.MONTAJ]: 'Montaj',
  [ORDER_STATUS.DELIVERED]: 'Teslim Edildi'
};

// Pagination Options
export const PAGINATION_OPTIONS = [5, 10, 15, 20, 25, 50, 100];

// Ödeme Tipleri
export const PAYMENT_TYPES = {
  CASH: 'cash',
  IBAN: 'iban',
  CREDIT_CARD: 'credit_card'
};

export const PAYMENT_TYPE_LABELS = {
  [PAYMENT_TYPES.CASH]: 'Elden Nakit',
  [PAYMENT_TYPES.IBAN]: 'IBAN',
  [PAYMENT_TYPES.CREDIT_CARD]: 'Kredi Kartı'
};

// WhatsApp Firma Listesi
export const WHATSAPP_FIRMA_LIST = [
  {
    id: 1,
    name: "Besa",
    phone: "905323992248",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 2,
    name: "By perdeci",
    phone: "905362111565",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 3,
    name: "Çankaya",
    phone: "905052636976",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 4,
    name: "DRN",
    phone: "905449151522",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 5,
    name: "Farbe",
    phone: "905357884885",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 6,
    name: "Hometex",
    phone: "905392721472",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 7,
    name: "Lilium",
    phone: "905373123081",
    defaultMessage: "Merhaba, sipariş detayları aşağıdaki gibidir:"
  },
  {
    id: 8,
    name: "Moss",
    phone: "905455166316",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 9,
    name: "Mysia",
    phone: "905339386947",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 10,
    name: "Perdelotti",
    phone: "905060995616",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 11,
    name: "Tüzemen",
    phone: "905397810632",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 12,
    name: "Yıldız Stor",
    phone: "905493608887",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 13,
    name: "İsmail Şengil",
    phone: "905349458135",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 14,
    name: "Gülsüm Şengil",
    phone: "905312079547",
    defaultMessage: "Yeni sipariş bilgileri:"
  }
]; 